/** 投注方向色：買漲/做多為綠，買跌/做空為紅 */
export function orderTrendClassName(trend) {
  const code = String(trend || '').trim().toUpperCase();
  if (code === 'UP' || code === 'LONG') {
    return 'text-profit';
  }
  if (code === 'DOWN' || code === 'SHORT') {
    return 'text-loss';
  }
  return '';
}

/** 盈虧狀態色：盈利綠、虧損紅 */
export function profitLossStatusClassName(status) {
  const code = String(status || '').trim().toUpperCase();
  if (code === 'WIN') {
    return 'text-profit';
  }
  if (code === 'LOSS') {
    return 'text-loss';
  }
  return '';
}

/**
 * 盈虧金額：正數加 + 並綠色，負數紅色
 * @returns {{ text: string, className: string }}
 */
export function formatSignedProfitLoss(value, fractionDigits = 2) {
  if (value == null || value === '') {
    return { text: '—', className: '' };
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return { text: String(value), className: '' };
  }
  const formatted = Math.abs(num).toFixed(fractionDigits);
  if (num > 0) {
    return { text: `+${formatted}`, className: 'text-profit' };
  }
  if (num < 0) {
    return { text: `-${formatted}`, className: 'text-loss' };
  }
  return { text: formatted, className: '' };
}
